"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.6 6.146a1.3 1.3 0 0 0-1.997-1.097l-5.85 3.713v5.01l5.85 3.712a1.3 1.3 0 0 0 1.997-1.097V6.147Zm-9.247 7.574V8.814h-3.5a2.453 2.453 0 1 0 0 4.905h3.5Zm.912-6.306 5.588-3.547C18.651 2.726 21 4.017 21 6.147v10.24c0 2.129-2.35 3.42-4.147 2.28l-5.588-3.548h-.578v3.119a2.321 2.321 0 0 1-4.642.037l-.052-3.252a3.854 3.854 0 0 1 .86-7.61h4.412Zm-3.87 7.706.05 3.133a.92.92 0 0 0 1.841-.015l.001-3.118H7.395Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MegaphoneIcon24.js.map